import type { Client } from '../types';

export interface ReferenceLogo {
  name: string;
  logo?: string;
  category?: string;
  isTypography?: boolean;
  subtitle?: string;
}

export const referenceLogos: ReferenceLogo[] = [
  // 1. Satır (1 - 6)
  { name: "SAPRO", logo: "/client-logos/sapro.svg", category: "Endüstri & Üretim" },
  { name: "KUTES", logo: "/client-logos/kutes.svg", category: "Endüstri & Döküm" },
  { name: "Alfa Solar Enerji", logo: "/client-logos/alfa-solar.png", category: "Yenilenebilir Enerji" },
  { name: "Seger", logo: "/client-logos/seger.png", category: "Otomotiv Yan Sanayi" },
  { name: "TaleWorlds Entertainment", logo: "/client-logos/taleworlds.png", category: "Oyun & Yazılım" },
  { name: "Turkcell BiP", logo: "/client-logos/bip.png", category: "Telekomünikasyon & App" },

  // 2. Satır (7 - 12)
  { name: "HP", logo: "/client-logos/hp.png", category: "Global Teknoloji" },
  { name: "Insider", logo: "/client-logos/insider.png", category: "MarTech & SaaS" },
  { name: "Setur", logo: "/client-logos/setur.png", category: "Turizm & Seyahat" },
  { name: "Barut Hotels", logo: "/client-logos/barut.svg", category: "Lüks Otelcilik" },
  { name: "Pınar", logo: "/client-logos/pinar.png", category: "Gıda & Tüketim" },
  { name: "Altınmarka", logo: "/client-logos/altinmarka.svg", category: "Gıda & Kakao" },

  // 3. Satır (13 - 18)
  { name: "Arma Kontrol", logo: "/client-logos/arma-kontrol.png", category: "Güvenlik Teknolojileri" },
  { name: "fonbulucu", logo: "/client-logos/fonbulucu.png", category: "FinTech & Kitle Fonlama" },
  { name: "Karsan", logo: "/client-logos/karsan.png", category: "Otomotiv & Ulaşım" },
  { name: "Kosifler", logo: "/client-logos/kosifler.png", category: "Lüks Otomotiv" },
  { name: "Azimut", logo: "/client-logos/azimut.png", category: "Lüks Yatçılık" },
  { name: "Teka Estetik", logo: "/client-logos/teka-estetik.png", category: "Medikal & Cihaz" },

  // 4. Satır (19 - 24) - 3B FAB ve Endocare
  { name: "3B FAB", logo: "/client-logos/3bfab.png", category: "3D & İleri Teknoloji" },
  { name: "Endocare", logo: "/client-logos/endocare.svg", category: "Dermokozmetik" },
  { name: "Heliocare", logo: "/client-logos/heliocare.png", category: "Dermokozmetik" },
  { name: "Dr. Gökhan Haytoğlu", logo: "/client-logos/gh-logo.png", category: "Medikal & Estetik" },
  { name: "OKM Detectors", logo: "/client-logos/okm.png", category: "Jeofizik & Tespit Cihazları" },
  { name: "Vivacy Stylage", logo: "/client-logos/vivacy-stylage.png", category: "Medikal Estetik" },

  // 5. Satır (25 - 30) - Tekstil, Moda & Üniversiteler
  { name: "Babuccu", logo: "/client-logos/babuccu.png", category: "Moda & Perakende" },
  { name: "Giorgio Di Mare", logo: "/client-logos/giorgio-di-mare.png", category: "Moda & Tekstil" },
  { name: "Dicle Tekstil", logo: "/client-logos/dicle-tekstil.svg", category: "Tekstil & Moda" },
  { name: "Bahçeşehir Üniversitesi (BAU)", logo: "/client-logos/bau-bahcesehir-universitesi.png", category: "Yüksek Öğretim" },
  { name: "Anadolu Üniversitesi", logo: "/client-logos/anadolu-universitesi.svg", category: "Yüksek Öğretim" },
  { name: "Mentora College", logo: "/client-logos/mentora.png", category: "Uluslararası Eğitim" },

  // 6. Satır (31 - 36) - Kültür, Medya & Tasarım
  { name: "Kristal Piksel", logo: "/client-logos/kristal-piksel.webp", category: "Oyun Ödülleri" },
  { name: "Global Sanat", logo: "/client-logos/global-sanat.png", category: "Sanat & Kültür" },
  { name: "Luys TV", logo: "/client-logos/tv-luys.png", category: "Televizyon & Yayıncılık" },
  { name: "Dergi Luys", logo: "/client-logos/dergi-luys.png", category: "Yazılı Basın & Medya" },
  { name: "Tuğra Restaurant", logo: "/client-logos/tugra-rest.png", category: "Lüks Gastronomi" },
  { name: "Kuğu Pastaneleri", logo: "/client-logos/kugu.png", category: "Gastronomi" },

  // 7. Satır (37 - 42) - Mimarlık, Hukuk & Okullar / Vakıflar
  { name: "Dr. Light", logo: "/client-logos/dr-light.png", category: "Aydınlatma & Mimari" },
  { name: "Keskin Güngör", logo: "/client-logos/keskin-gungor.png", category: "Hukuk & Danışmanlık" },
  { name: "Esayan Okulu", isTypography: true, subtitle: "Eğitim Kurumu", category: "Kültür & Eğitim" },
  { name: "Karagözyan Vakfı", isTypography: true, subtitle: "Vakıf & Eğitim", category: "Kültür & Eğitim" },
  { name: "Dadyan Okulu", isTypography: true, subtitle: "Eğitim Kurumu", category: "Kültür & Eğitim" },
  { name: "Sahakyan Okulu", isTypography: true, subtitle: "Eğitim Kurumu", category: "Kültür & Eğitim" },

  // 8. Satır (43 - 48) - Miras, Müzik & Sanat
  { name: "Gazturman Gayan", isTypography: true, subtitle: "Kültür & Miras", category: "Kültür & Miras" },
  { name: "Maral Müzik Ve Dans Topluluğu", isTypography: true, subtitle: "Sahne Sanatları", category: "Sahne Sanatları" },
  { name: "Türkiye Futbol Vakfı", isTypography: true, subtitle: "Spor & STK", category: "Spor & STK" },
  { name: "Güney Marlen", isTypography: true, subtitle: "Müzisyen & Sanatçı", category: "Müzik & Sanat" },
  { name: "Eda Baba", isTypography: true, subtitle: "Müzisyen & Yorumcu", category: "Müzik & Sanat" },
  { name: "Ezginin Günlüğü", isTypography: true, subtitle: "Müzik Topluluğu", category: "Müzik Topluluğu" },

  // 9. Satır (49 - 51) - Medya, Moda & Spor
  { name: "Çağla Gürsoy", isTypography: true, subtitle: "Moda & Lifestyle", category: "Moda & Medya" },
  { name: "Kadir Çöpdemir", isTypography: true, subtitle: "Medya & Radyo", category: "Medya & Yayın" },
  { name: "Sergen Yalçın", isTypography: true, subtitle: "Spor & Medya", category: "Spor & Medya" }
];

export const clients: Client[] = [
  // Endüstri ve Üretim
  { name: "SAPRO", category: "Endüstri ve Üretim", logoUrl: "/client-logos/sapro.svg" },
  { name: "KUTES", category: "Endüstri ve Üretim", logoUrl: "/client-logos/kutes.svg" },
  { name: "Alfa Solar", category: "Endüstri ve Üretim", logoUrl: "/client-logos/alfa-solar.png" },
  { name: "Seger", category: "Endüstri ve Üretim", logoUrl: "/client-logos/seger.png" },
  { name: "3B FAB", category: "Endüstri ve Üretim", logoUrl: "/client-logos/3bfab.png" },
  { name: "Dicle Tekstil", category: "Endüstri ve Üretim", logoUrl: "/client-logos/dicle-tekstil.svg" },
  
  // Sağlık ve Medikal Estetik
  { name: "Endocare", category: "Sağlık ve Medikal Estetik", logoUrl: "/client-logos/endocare.svg" },
  { name: "Heliocare", category: "Sağlık ve Medikal Estetik", logoUrl: "/client-logos/heliocare.png" },
  { name: "Teka Estetik", category: "Sağlık ve Medikal Estetik", logoUrl: "/client-logos/teka-estetik.png" },
  { name: "Dr. Gökhan Haytoğlu", category: "Sağlık ve Medikal Estetik", logoUrl: "/client-logos/gh-logo.png" },
  { name: "OKM Türkiye", category: "Sağlık ve Medikal Estetik", logoUrl: "/client-logos/okm.png" },
  { name: "Vivacy Stylage", category: "Sağlık ve Medikal Estetik", logoUrl: "/client-logos/vivacy-stylage.png" },
  
  // Teknoloji ve Oyun
  { name: "TaleWorlds Entertainment", category: "Teknoloji ve Oyun", logoUrl: "/client-logos/taleworlds.png" },
  { name: "Turkcell BiP", category: "Teknoloji ve Oyun", logoUrl: "/client-logos/bip.png" },
  { name: "HP", category: "Teknoloji ve Oyun", logoUrl: "/client-logos/hp.png" },
  { name: "Insider", category: "Teknoloji ve Oyun", logoUrl: "/client-logos/insider.png" },
  
  // Kültür, Eğlence ve Spor
  { name: "Kristal Piksel", category: "Kültür, Eğlence ve Medya", logoUrl: "/client-logos/kristal-piksel.webp" },
  { name: "Global Sanat", category: "Kültür, Eğlence ve Medya", logoUrl: "/client-logos/global-sanat.png" },
  { name: "Luys Media", category: "Kültür, Eğlence ve Medya", logoUrl: "/client-logos/tv-luys.png" },
  { name: "Türkiye Futbol Vakfı", category: "Kültür, Eğlence ve Medya", isTypography: true, subtitle: "Spor & STK" },
  { name: "Gazturman Gayan", category: "Kültür, Eğlence ve Medya", isTypography: true, subtitle: "Kültür & Miras" },
  { name: "Karagözyan Vakfı", category: "Kültür, Eğlence ve Medya", isTypography: true, subtitle: "Vakıf & Eğitim" },
  { name: "Esayan Okulu", category: "Kültür, Eğlence ve Medya", isTypography: true, subtitle: "Eğitim Kurumu" },
  { name: "Dadyan Okulu", category: "Kültür, Eğlence ve Medya", isTypography: true, subtitle: "Eğitim Kurumu" },
  { name: "Sahakyan Okulu", category: "Kültür, Eğlence ve Medya", isTypography: true, subtitle: "Eğitim Kurumu" },
  { name: "Maral Müzik Ve Dans Topluluğu", category: "Kültür, Eğlence ve Medya", isTypography: true, subtitle: "Sahne Sanatları" },
  { name: "Anadolu Üniversitesi", category: "Kültür, Eğlence ve Medya", logoUrl: "/client-logos/anadolu-universitesi.svg" },
  { name: "Güney Marlen", category: "Kültür, Eğlence ve Medya", isTypography: true, subtitle: "Müzisyen & Sanatçı" },
  { name: "Eda Baba", category: "Kültür, Eğlence ve Medya", isTypography: true, subtitle: "Müzisyen & Yorumcu" },
  { name: "Ezginin Günlüğü", category: "Kültür, Eğlence ve Medya", isTypography: true, subtitle: "Müzik Topluluğu" },
  { name: "Çağla Gürsoy", category: "Kültür, Eğlence ve Medya", isTypography: true, subtitle: "Moda & Lifestyle" },
  { name: "Kadir Çöpdemir", category: "Kültür, Eğlence ve Medya", isTypography: true, subtitle: "Medya & Radyo" },
  { name: "Sergen Yalçın", category: "Kültür, Eğlence ve Medya", isTypography: true, subtitle: "Spor & Medya" },
  
  // Kurumsal ve Hizmet
  { name: "Arma Kontrol", category: "Kurumsal ve Hizmet", logoUrl: "/client-logos/arma-kontrol.png" },
  { name: "Altınmarka", category: "Kurumsal ve Hizmet", logoUrl: "/client-logos/altinmarka.svg" },
  { name: "Fonbulucu", category: "Kurumsal ve Hizmet", logoUrl: "/client-logos/fonbulucu.png" },
  { name: "Pınar", category: "Kurumsal ve Hizmet", logoUrl: "/client-logos/pinar.png" },
  { name: "Setur", category: "Kurumsal ve Hizmet", logoUrl: "/client-logos/setur.png" },
  { name: "Barut Hotels", category: "Kurumsal ve Hizmet", logoUrl: "/client-logos/barut.svg" },
  { name: "Azimut", category: "Kurumsal ve Hizmet", logoUrl: "/client-logos/azimut.png" },
  { name: "Babuccu", category: "Kurumsal ve Hizmet", logoUrl: "/client-logos/babuccu.png" },
  { name: "Giorgio Di Mare", category: "Kurumsal ve Hizmet", logoUrl: "/client-logos/giorgio-di-mare.png" },
  { name: "Kosifler", category: "Kurumsal ve Hizmet", logoUrl: "/client-logos/kosifler.png" },
  { name: "Karsan", category: "Kurumsal ve Hizmet", logoUrl: "/client-logos/karsan.png" },
  { name: "Kuğu Pastaneleri", category: "Kurumsal ve Hizmet", logoUrl: "/client-logos/kugu.png" },
  { name: "Tuğra Restaurant", category: "Kurumsal ve Hizmet", logoUrl: "/client-logos/tugra-rest.png" }
];
